import SearchFilterTab from '@components/cockpit/panels/notificationSearch/categoryFilters/SearchFilterTab';
import {
  DurationFilter,
  MaxAltitudeOrHeightFilter,
  PeriodFilter,
  ReliabilityFilter,
  WorstClassificationFilter,
} from '@components/cockpit/panels/notificationSearch/filterComponents/AdditionalFilters';
import { SearchFilterOptionEnum } from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { useNotificationSearchContext } from '@components/cockpit/panels/notificationSearch/NotificationSearchContext';
import { useAppSelector } from '@hooks/redux.hooks';
import { hasRole } from '@redux/authent/authent.selectors';
import { RootState } from '@redux/store';
import { useState } from 'react';

import { RoleEnum } from '@/types/authent/roles.types';
import { NotificationFamilyEnum } from '@/types/data/data.types';

import { IdentifierFilter, PlatformFilter, SensorFilter, ZoneFilter } from '../filterComponents/SearchFilters';

export default function LADFilters() {
  const { filters, displayedFilterOptions } = useNotificationSearchContext();
  const canAccessNFZ = useAppSelector((state: RootState) => hasRole(state, RoleEnum.ACCESS_ZONE_NFZ));

  const [resetKey, setResetKey] = useState(0);

  return (
    <SearchFilterTab
      category={NotificationFamilyEnum.LAD}
      onReset={() => {
        setResetKey((prev) => prev + 1);
      }}
    >
      {displayedFilterOptions.has(SearchFilterOptionEnum.PLATFORM) && <PlatformFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.COLLABORATIVE_ID) && <IdentifierFilter isCollaborative />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.ID) && <IdentifierFilter />}
      {canAccessNFZ && displayedFilterOptions.has(SearchFilterOptionEnum.ZONES) && <ZoneFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.TRACK_SENSOR) && <SensorFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.WORST_CLASSIFICATION) && <WorstClassificationFilter />}
      <PeriodFilter key={`${filters.category}-${resetKey}`} isDetection />
      {displayedFilterOptions.has(SearchFilterOptionEnum.RELIABILITY) && <ReliabilityFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.MAX_ALTITUDE_OR_HEIGHT) && <MaxAltitudeOrHeightFilter />}
      {displayedFilterOptions.has(SearchFilterOptionEnum.DETECTION_DURATION) && <DurationFilter isDetection />}
    </SearchFilterTab>
  );
}
